<template>
  <div>
    <Navbar />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Operasi" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <Alert
            v-if="saveFailed"
            :alert="{
              type: 'danger',
              title: 'Gagal Menyimpan Data',
              content:
                'Terjadi kesalahan saat menyimpan data, mohon periksa kembali data yang Anda masukkan',
            }"
          />
          <Alert
            v-if="saveSuccess"
            :alert="{
              type: 'success',
              title: 'Berhasil Menyimpan Data',
              content: 'Penyimpanan data berhasil dilakukan',
            }"
          />
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />
          <IntroOperasi
            :detailTop="introRalanOperasi.introRalan"
            :detailBottom="introRalanOperasi.introOperasi"
            :steps="steps"
          />
          <!--form action="/ranap/save" method="POST" enctype="multipart/form-data"-->
          <div class="row mb-2 mt-4">
            <div class="col-md-12">
              <FormRow
                v-for="row in upperForm"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />
            </div>
          </div>
          <hr />
          <div class="row mb-5">
            <div class="col-md-6">
              <h4 class="mb-3 text-primary">Pre Operasi</h4>
              <b-card class="p-0">
                <FormRow
                  v-for="row in leftForm"
                  v-bind:key="row.colnum + String(Math.random(1023))"
                  :row="row"
                  @handleChange="(e) => handleChange(e)"
                />
              </b-card>
            </div>
            <div class="col-md-6">
              <h4 class="mb-3 text-primary">Post Operasi</h4>
              <b-card class="p-0">
                <FormRow
                  v-for="row in rightForm"
                  v-bind:key="row.colnum + String(Math.random(1023))"
                  :row="row"
                  @handleChange="(e) => handleChange(e)"
                />
              </b-card>
            </div>
          </div>
          <div class="py-1 my-5"></div>
          <div class="card p-3 float-bottom">
            <div class="row">
              <div class="col-md-12">
                <button
                  @click="saveAndContinue"
                  class="
                    btn btn-primary btn-with-icon-left
                    float-right
                    ml-3
                    text-uppercase
                  "
                >
                  <i class="material-symbols-outlined">check_circle</i>
                  SIMPAN
                </button>
                <button
                  class="btn btn-outline-danger float-right text-uppercase mr-3"
                  @click="cancel"
                >
                  BATALKAN
                </button>
              </div>
            </div>
          </div>

          <!--/form-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import FormRow from "@/components/FormRow.vue";
import IntroOperasi from "@/components/IntroOperasi.vue";
import Alert from "@/components/Alert.vue";
import { setOperationIntro, getFullUrl } from "@/data/helper.js";
// import { HTTP } from "@/config.js";
import { upperForm, leftForm, rightForm } from "@/data/OperasiFormKondisi.js";
import { dataKondisi } from "@/data/OperasiForm.js";
export default {
  name: "OperasiFormKondisi",
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    FormRow,
    Alert,
    IntroOperasi,
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      data: dataKondisi,
      detailTop: null,
      upperForm: upperForm,
      leftForm: leftForm,
      rightForm: rightForm,
      operasiKondisi: null,
      introRalanOperasi: { introRalan: {}, introOperasi: [] },
      steps: [],
      ralan: {},
      operasi: {},
      id_kondisi: null,
      formSet: {
        id_operasi: null,
        pre_daerah_operasi: 0,
        pre_daerah_operasi_keterangan: "",
        pre_puasa: 0,
        pre_puasa_keterangan: "",
        pre_klisma: 0,
        pre_klisma_keterangan: "",
        pre_surat_izin: 0,
        pre_surat_izin_keterangan: "",
        pre_tanda_vital: 0,
        pre_tanda_vital_keterangan: "",
        pre_katheter: 0,
        pre_katheter_keterangan: "",
        pre_infus: 0,
        pre_infus_keterangan: "",
        pre_premedikasi: 0,
        pre_premedikasi_keterangan: "",
        pre_alergi: 0,
        pre_alergi_keterangan: "",
        pre_perhiasan: 0,
        pre_perhiasan_keterangan: "",
        pre_make_up: 0,
        pre_make_up_keterangan: "",
        pre_aksesoris: 0,
        pre_aksesoris_keterangan: "",
        pre_hasil_lab: 0,
        pre_hasil_lab_keterangan: "",
        pre_status: 0,
        pre_status_keterangan: "",
        pre_persediaan_darah: 0,
        pre_persediaan_darah_keterangan: "",
        pre_pilek_batuk: 0,
        pre_pilek_batuk_keterangan: "",
        pre_darah: 0,
        pre_darah_keterangan: "",
        pre_pemeriksaan: 0,
        pre_pemeriksaan_keterangan: "",
        pre_haid: 0,
        pre_haid_keterangan: "",
        pre_konsul_anestesi: 0,
        pre_konsul_anestesi_keterangan: "",
        pre_acc_adm_kasir: 0,
        pre_acc_adm_kasir_keterangan: "",
        post_infus: 0,
        post_infus_keterangan: "",
        post_ngt: 0,
        post_ngt_keterangan: "",
        post_drain: 0,
        post_drain_keterangan: "",
        post_tampon: 0,
        post_tampon_keterangan: "",
        post_katheter: 0,
        post_katheter_keterangan: "",
        post_pemeriksaan: 0,
        post_pemeriksaan_keterangan: "",
        post_laporan_pembedahan: 0,
        post_laporan_pembedahan_keterangan: "",
        post_instruksi: 0,
        post_instruksi_keterangan: "",
        post_laporan_anestesi: 0,
        post_laporan_anestesi_keterangan: "",
        post_resep: 0,
        post_resep_keterangan: "",
        post_hasil_lab: 0,
        post_hasil_lab_keterangan: "",
        post_darah_sisa: 0,
        post_darah_sisa_keterangan: "",
        post_format_biaya: 0,
        post_format_biaya_keterangan: "",
        post_format_observasi: 0,
        post_format_observasi_keterangan: "",
        post_tanda_vital_td: 0,
        post_tanda_vital_td_keterangan: "",
        post_tanda_vital_n: 0,
        post_tanda_vital_n_keterangan: "",
        post_tanda_vital_r: 0,
        post_tanda_vital_r_keterangan: "",
        post_tanda_vital_s: 0,
        post_tanda_vital_s_keterangan: "",
        post_tanda_vital_spo2: 0,
        post_tanda_vital_spo2_keterangan: "",
        tanggal: "",
        sign_in: "",
        sign_out: "",
      },
      inputTexts: [
        "pre_daerah_operasi_keterangan",
        "pre_puasa_keterangan",
        "pre_klisma_keterangan",
        "pre_surat_izin_keterangan",
        "pre_tanda_vital_keterangan",
        "pre_katheter_keterangan",
        "pre_infus_keterangan",
        "pre_premedikasi_keterangan",
        "pre_alergi_keterangan",
        "pre_perhiasan_keterangan",
        "pre_make_up_keterangan",
        "pre_aksesoris_keterangan",
        "pre_hasil_lab_keterangan",
        "pre_status_keterangan",
        "pre_persediaan_darah_keterangan",
        "pre_pilek_batuk_keterangan",
        "pre_darah_keterangan",
        "pre_pemeriksaan_keterangan",
        "pre_haid_keterangan",
        "pre_konsul_anestesi_keterangan",
        "pre_acc_adm_kasir_keterangan",
        "post_infus_keterangan",
        "post_ngt_keterangan",
        "post_drain_keterangan",
        "post_tampon_keterangan",
        "post_katheter_keterangan",
        "post_pemeriksaan_keterangan",
        "post_laporan_pembedahan_keterangan",
        "post_instruksi_keterangan",
        "post_laporan_anestesi_keterangan",
        "post_resep_keterangan",
        "post_hasil_lab_keterangan",
        "post_darah_sisa_keterangan",
        "post_format_biaya_keterangan",
        "post_format_observasi_keterangan",
        "post_tanda_vital_td_keterangan",
        "post_tanda_vital_n_keterangan",
        "post_tanda_vital_r_keterangan",
        "post_tanda_vital_s_keterangan",
        "post_tanda_vital_spo2_keterangan",
      ],
      saveSuccess: false,
      saveFailed: false,
    };
  },
  methods: {
    save: async function() {
      this.handleForm();
    },
    continue: function() {
      this.$router.push(
        `/operasi/detail/${this.$route.params.id_ralan}/${this.$route.params.id}?tab=5`
      );
    },
    cancel: function() {
      this.$router.push(
        `/operasi/detail/${this.$route.params.id_ralan}/${this.$route.params.id}?tab=5`
      );
    },
    saveAndContinue: async function() {
      this.handleForm(this.continue);
    },
    handleForm: async function(callback) {
      this.errors = [];
      let formData = new FormData();
      let body = "";
      let formData2 = new FormData();
      var self = this;
      //console.log(this.formSet);
      let valid = this.validateForm();
      if (valid) {
        Object.keys(this.formSet).forEach(function(key) {
          //console.log("==================formdata========");
          //console.log(key);
          //console.log(self.formSet[key]);
          //console.log("==================formdata========");

          if (["sign_in", "tanggal", "sign_out"].indexOf(key) > -1) {
            formData2.append(key, self.formSet[key]);
          } else {
            if (self.id_kondisi) {
              if (!self.formSet[key]) {
                if (self.inputTexts.indexOf(key) > -1) {
                  body += `${key}=&`;
                } else {
                  body += `${key}=0&`;
                }
              } else {
                body += `${key}=${self.formSet[key]}&`;
                // formData.append(key, self.formSet[key]);
              }
            } else {
              if (!self.formSet[key]) {
                if (self.inputTexts.indexOf(key) > -1) {
                  formData.append(key, "");
                } else {
                  formData.append(key, 0);
                }
              } else {
                formData.append(key, self.formSet[key]);
              }
            }
          }
        });
        try {
          let result;
          //console.log('Id Laporan: '+this.id_kondisi);
          result = await this.$store.state.HTTP.post(
            "operasi/" + this.$route.params.id,
            formData2
          );
          //console.log(result);
          //console.log(body);
          if (this.id_kondisi) {
            //console.log("operasi_kondisi/" + this.id_kondisi);
            result = await this.$store.state.HTTP.put(
              "operasi_kondisi/" + this.id_kondisi,
              body
            );
          } else {
            result = await this.$store.state.HTTP.post(
              "operasi_kondisi",
              formData
            );
          }
          //console.log(result);
          if (result.status == "200") {
            //console.log('success');
            //console.log(result);
            this.saveFailed = false;
            this.saveSuccess = true;
            var that = this;
            setTimeout(function() {
              that.saveSuccess = false;
              // that.$router.push(`/ralan/detail/${that.$route.params.id}`);
              if (callback) {
                callback();
              } else {
                that.$router.push(
                  `/operasi/form-kondisi/${that.$route.params.id_ralan}/${that.$route.params.id}?fromTab=5`
                );
              }
            }, 1000);
          } else {
            //console.log(result.status);
            this.errors.push(result.status);
            this.saveFailed = true;
          }
        } catch (e) {
          //console.log(e);
          this.errors.push(e);
          this.saveFailed = true;
        }
      } else {
        //console.log("tidak valid");
      }
    },
    handleChange(e) {
      if (e.target.type == "file") {
        if (e.target.files && e.target.files.length) {
          this.formSet[e.target.name] = e.target.files[0];
        }
      } else {
        //console.log("====================onchange===========");
        //console.log(e.target.name);
        //console.log(e.target.value);
        //console.log("====================onchange===========");
        this.formSet[e.target.name] = e.target.value;
      }
      //console.log(this.formSet[e.target.name]);
    },

    validateForm: function() {
      let valid = true;
      let self = this;
      //console.log(self.formSet);
      let forms = [this.upperForm, this.leftForm, this.rightForm].map(function(
        form
      ) {
        form = form.map(function(row) {
          row.columns = row.columns.map(function(column) {
            if (
              !column.optional &&
              column.type != "hidden" &&
              !self.formSet[column.name] &&
              self.formSet[column.name] != 0
            ) {
              valid = false;
              column.error = "Kolom ini wajib diisi";
            } else if (
              [
                "number",
                "money",
                "addon-right",
                "addon-left",
                "percentage",
              ].indexOf(column.type) > -1 &&
              !column.negativeValue &&
              parseInt(self.formSet[column.name]) < 0
            ) {
              valid = false;
              column.error = "Nilai yang diisi tidak boleh negatif";
            } else {
              column.error = "";
            }
            if (self.formSet[column.name]) {
              if (column.type == "file") {
                var reader = new FileReader();
                reader.onload = function(e) {
                  column.value = e.target.result;
                };
                reader.readAsDataURL(self.formSet[column.name]);
              } else {
                column.value = self.formSet[column.name];
              }
            }
            return column;
          });
          return row;
        });
        return form;
      });
      this.upperForm = forms[0];
      this.leftForm = forms[1];
      this.rightForm = forms[2];
      return valid;
    },
    fetchData: async function() {
      let result = await this.$store.state.HTTP.get(
        `operasi_kondisi?id_operasi=${this.$route.params.id}`
      );
      //console.log(result);
      //console.log(result.data);
      //console.log(result.data.data);
      if (result.data.data.length) {
        this.id_kondisi = result.data.data[0].id;
        let self = this;
        let result2 = await this.$store.state.HTTP.get(
          `operasi_kondisi/${this.id_kondisi}`
        );
        //console.log(result2);
        this.operasiKondisi = result2.data;
        Object.keys(this.formSet).forEach(function(key) {
          if (["sign_in", "tanggal", "sign_out"].indexOf(key) > -1) {
            // self.formSet[key]=self.operasiKondisi.operasi[key];
          } else {
            if (key == "pre_induksi_file_penandaan") {
              self.formSet[key] = null;
              var url = getFullUrl(
                self.$store.state.baseStorageURL,
                self.operasiKondisi[key]
              );
              self.leftForm[3].columns[0].current_file_url = url;
            } else {
              if (self.operasiKondisi[key]) {
                self.formSet[key] = self.operasiKondisi[key];
              } else {
                if (
                  [
                    "pre_induksi_resiko_darah_ketersediaan",
                    "pre_pembedahan_anestesi_monitor_keterangan",
                    "pre_pembedahan_perawat_instrumen_khusus_keterangan",
                    "post_masalah_peralatan_keterangan",
                    "post_perhatian_pasien",
                  ].indexOf(key) > -1
                ) {
                  self.formSet[key] = "";
                }
              }
            }
          }
        });
        this.updateForm();
      }
    },
    updateForm() {
      let self = this;
      let forms = [this.upperForm, this.leftForm, this.rightForm].map(function(
        form
      ) {
        form = form.map(function(row) {
          row.columns = row.columns.map(function(column) {
            if (column.type == "file") {
              if (self.formSet[column.name]) {
                var reader = new FileReader();
                reader.onload = function(e) {
                  column.value = e.target.result;
                };
                reader.readAsDataURL(self.formSet[column.name]);
              }
            } else {
              column.value = self.formSet[column.name];
            }
            return column;
          });
          return row;
        });
        return form;
      });
      this.upperForm = forms[0];
      this.leftForm = forms[1];
      this.rightForm = forms[2];
    },
    fetchNurses: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          `petugas?per_page=9999999999`
        );
        if (result.status == "200") {
          this.upperForm[0].columns[0].options = result.data.data.map(
            (item) => {
              return { value: item.id, label: item.nama };
            }
          );
          if (!this.formSet.id_petugas) {
            this.formSet.id_petugas = this.$store.state.id_petugas || "";
            if (this.formSet.id_petugas) {
              this.upperForm[0].columns[0].value = this.formSet.id_petugas;
            }
          }
        } else {
          this.displayNotFoundError();
        }
      } catch (e) {
        //console.log(e);
      }
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  // created() {
  //   window.addEventListener(
  //     "hashchange",
  //     () => {
  //       // Do something when the hash changes
  //       location.reload();
  //     },
  //     false
  //   );
  // },
  mounted: async function() {
    this.formSet["id_operasi"] = this.$route.params.id;
    try {
      let result = await this.$store.state.HTTP.get(
        `operasi/${this.$route.params.id}`
      );
      //console.log(result);
      if (result.status == 200) {
        this.operasi = result.data;
        this.formSet.tanggal = this.operasi.tanggal;
        this.formSet.sign_in = this.operasi.sign_in;
        this.formSet.sign_out = this.operasi.sign_out;
        this.updateForm();
        let result2 = await this.$store.state.HTTP.get(
          `ralan/${this.operasi.id_ralan}`
        );
        this.ralan = result2.data;
        this.introRalanOperasi = setOperationIntro(this.ralan, this.operasi);
      } else {
        this.displayNotFoundError();
      }
    } catch (e) {
      //console.log(e);
    }
    await this.fetchData();
    await this.fetchNurses();
  },
};
</script>
